export default 0.00965657561559313;
